import { utilAnimationTicketManager } from "../utils/utilAnimationTicketManager";
// This class manages the spawn of a Required animation.
// Required animations spawn in two ways:
// 1)   Under a certain threshold a spawn is mandatory
//      e.g. if the threshold is 3 and there is only 1 animation active,
//      2 animations are forced to spawn.
// 2)   If they are not forced to spawn they have a % chance to be spawned.
var AnimationManager = /** @class */ (function () {
    function AnimationManager() {
        var _this = this;
        /**
         * (re)Sets animation loop params and start the loop.
         * @param container the container which will contain the animation
         * @param id the id to use for the animation
         */
        this.setAnimationLoop = function (container, id) {
            // set params.
            _this.id = id;
            _this.container = container;
            // start the loop.
            _this._startAnimationLoop();
        };
        /**
         * Remove completely the animation.
         * This includes both the container and the timers.
         * @param restartLoop
         * If set to true the loop is restarted.
         */
        this.removeAnimation = function (restartLoop) {
            // This is necessary since the function is called from outside and a
            // removeChildTimeOut interval may still be running.
            clearTimeout(_this.removeChildTimeOut);
            _this._removeAnimation(restartLoop);
        };
        /**
         * The function used in the loop which will try to start the animation.
         */
        this.tryStartAnimation = function () {
            var animationGranted = utilAnimationTicketManager.animate(_this.animationType, _this.id, _this.spawnChancePercentage);
            if (animationGranted) {
                setTimeout(function () {
                    _this.animationContainer = _this.addAnimationToCanvas();
                    _this.removeChildTimeOut = setTimeout(_this._removeAnimation, _this.animationDuration);
                }, Math.floor(Math.random() * _this.maxStartingDelay));
            }
        };
        /**
         * the function which actually adds the animation to the canvas.
         */
        this.addAnimationToCanvas = function () {
            var animationToAdd = _this.generateAnimation();
            _this.container.addChild(animationToAdd);
            return animationToAdd;
        };
        /**
         * the function which actually removes the animation from the canvas and which
         * can restart the loop.
         * @param restartLoop
         * If this is set to true, the loop of the animation will start again.
         * @private
         * Use removeAnimation to call this from outside: the trySpawnChildInterval will generate
         * issues if not cleared via trySpawnChildInterval!
         * (and it is also handled already by the regular animation, so no need to clear it here.)
         */
        this._removeAnimation = function (restartLoop) {
            if (restartLoop === void 0) { restartLoop = true; }
            var animationContainer = _this.animationContainer;
            if (animationContainer != undefined) {
                _this.container.removeChild(animationContainer);
                animationContainer.destroy();
            }
            if (restartLoop) {
                utilAnimationTicketManager.stopAnimation(_this.animationType, _this.id);
            }
            else {
                utilAnimationTicketManager.clearAnimationId(_this.animationType, _this.id);
                clearInterval(_this.trySpawnChildInterval);
            }
            clearTimeout(_this.removeChildTimeOut);
        };
        /**
         * Start the animation loop.
         * @private
         * Use startAnimationLoop to call this from outside: if this starts parameter-less,
         * nothing will be displayed!
         */
        this._startAnimationLoop = function () {
            utilAnimationTicketManager.addNewAnimationId(_this.animationType, _this.id);
            _this.trySpawnChildInterval = setInterval(function () { return _this.tryStartAnimation(); }, _this.animationRepeatInterval);
        };
    }
    return AnimationManager;
}());
export { AnimationManager };



//////////////////
// WEBPACK FOOTER
// ./src/graphics/AnimationManager.ts
// module id = 2198
// module chunks = 3